import CollapsedDrawer from './collapsed/collapsed';
import ExpandedDrawer from './expanded/expanded';

const AiScribeDrawer = () => {
  return (
    <>
      <CollapsedDrawer />
      <ExpandedDrawer />
    </>
  );
};

export default AiScribeDrawer;
